import React from 'react';
import { RouteComponentProps, useParams } from 'react-router';
import { PageContent } from '../components/page/PageContent';
import { usePages } from '../hooks/WPHooks';
import { FormattedMessage } from 'react-intl';
import { AppPage } from '../AppContent';

interface PageProps extends RouteComponentProps {}

export const Page: React.FC<PageProps> = ({ history }) => {
  const { slug, slug1, slug2 }: any = useParams();

  const slugs: string[] = [slug, slug1, slug2].filter((s) => s);

  const { pages } = usePages();

  return (
    <AppPage>
      <div className="px-4 md:px-14">
        <button
          onClick={() => history.goBack()}
          className="text-primary block text-xs ml-2 mt-5 md:hidden"
        >
          <FormattedMessage id="Go back" />
        </button>

        {pages.length > 0 && (
          <PageContent pages={pages} slugs={slugs} baseLink="/pages" />
        )}
      </div>
    </AppPage>
  );
};
